<div class="taas-hero-art" aria-hidden="true">
  <div class="taas-hero-art__glow taas-hero-art__glow--one"></div>
  <div class="taas-hero-art__glow taas-hero-art__glow--two"></div>

  <div class="taas-hero-art__layer taas-hero-art__layer--issues">
    <img src="/assets/img/taas-hero/issues_verifiable_credentials.svg" alt="" />
  </div>

  <div class="taas-hero-art__layer taas-hero-art__layer--registry">
    <img src="/assets/img/taas-hero/live_registry.svg" alt="" />
  </div>

  <div class="taas-hero-art__layer taas-hero-art__layer--certificate">
    <img src="/assets/img/taas-hero/certificate_of_accreditation.svg" alt="" />
  </div>

  <div class="taas-hero-art__layer taas-hero-art__layer--confirmed">
    <div class="taas-hero-art__tilt">
      <img src="/assets/img/taas-hero/confirmed_public_register.svg" alt="" />
    </div>
  </div>

  <div class="taas-hero-art__layer taas-hero-art__layer--recognised">
    <img src="/assets/img/taas-hero/ctin_ican_anan_.svg" alt="" />
  </div>
</div>
